import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Icon } from "@mui/material";
import { keyframes } from "@emotion/react";
import { fadeInUp } from "../../utils/animations";

const bounce = keyframes`
  0%, 100% { transform: scale(1); }
  30% { transform: scale(1.15); }
  50% { transform: scale(0.95); }
  70% { transform: scale(1.05); }
`;

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
        textAlign="center"
        px={3}
      >
        <Icon
          sx={{
            fontSize: "80px !important",
            color: "#186A81",
            mb: 2,
            animation: `${bounce} 0.8s ease-out`,
          }}
        >
          lock
        </Icon>
        <MDTypography
          variant="h3"
          fontWeight="bold"
          color="dark"
          mb={1}
          sx={{ animation: `${fadeInUp} 0.6s ease-out 0.2s both` }}
        >
          Accès non autorisé
        </MDTypography>
        <MDTypography
          variant="body1"
          color="text"
          mb={4}
          sx={{ maxWidth: 500, animation: `${fadeInUp} 0.6s ease-out 0.35s both` }}
        >
          Vous n&apos;avez pas les permissions nécessaires pour accéder à cette page.
        </MDTypography>
        <MDButton
          variant="gradient"
          color="purple"
          size="large"
          onClick={() => navigate("/dashboard")}
          sx={{
            animation: `${fadeInUp} 0.6s ease-out 0.5s both`,
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "translateY(-3px)",
              boxShadow: "0 8px 25px rgba(123,31,162,0.3)",
            },
          }}
        >
          <Icon sx={{ mr: 1 }}>home</Icon>
          Retour au Dashboard
        </MDButton>
      </MDBox>
    </DashboardLayout>
  );
}

export default Unauthorized;
